import React from 'react';

import type { Node } from './../../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import { Node_Type } from './../../../ricos-schema/legacy/wix/rich_content/v1/index.js';

export const Anchor = React.memo<{
  anchorKey: string;
  type?: string;
}>(({ anchorKey, type }) => (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  <div key={anchorKey} type={type} data-hook={anchorKey} /> //'type' attribute is for wix corvid
));

const isEmptyRichTextNode = (node: Node) =>
  [Node_Type.PARAGRAPH, Node_Type.HEADING, Node_Type.BLOCKQUOTE, Node_Type.CODE_BLOCK].includes(
    node.type
  ) && !node.nodes?.length;

export const getAnchor = (node: Node, nodeIndex: number, addAnchorsPrefix: string) => {
  const anchorType = isEmptyRichTextNode(node) ? 'empty-line' : node.type.toLowerCase();
  const anchorKey = `${addAnchorsPrefix}${nodeIndex + 1}`;
  return <Anchor key={anchorKey} type={anchorType} anchorKey={anchorKey} />;
};
